export const Login = 'LOGIN'
export const Logout = 'LOGOUT'
export const ME = 'ME'
export const update='UPDATE_ME'
